import { QuestionMarkCircleIcon } from '@heroicons/react/16/solid'
import type { ReactNode } from 'react'
import type { DraftState, WizardQuestion } from '../../../Model/OrderWizard/OrderWizardDraft.ts'
import type { IssueSeverity } from '../../../Services/OrderWizard/issues.ts'
import { Callout } from './Primitives.tsx'

/** A card's main answer is primary only when it is the screen's next action; the others are secondary. */
export const answerClass = (primary: boolean) => `btn btn-sm ${primary ? 'btn-primary' : ''}`

export const QuestionCardFrame = ({ title, tone = 'warning', children }: { title: string; tone?: IssueSeverity; children: ReactNode }) => (
  <Callout tone={tone} className="rounded-lg bg-white p-3 transition-shadow" data-testid="wizard-question">
    <p className="mb-1 flex items-center gap-1.5 font-medium text-slate-900">
      <QuestionMarkCircleIcon className={`h-4 w-4 shrink-0 ${tone === 'blocker' ? 'text-red-500' : 'text-amber-500'}`} /> {title}
    </p>
    {children}
  </Callout>
)

export type CardProps<K extends WizardQuestion['kind']> = {
  draft: DraftState
  question: Extract<WizardQuestion, { kind: K }>
  primary: boolean
}
